/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_8ddbc6c5{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.rootVertical_8ddbc6c5{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.item_8ddbc6c5{-ms-flex-negative:0;flex-shrink:0;display:inherit}\n"}]);
export const root = "root_8ddbc6c5";
export const rootVertical = "rootVertical_8ddbc6c5";
export const item = "item_8ddbc6c5";